if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText =
          this.submitButton.querySelector('.product-form__submit-text') || this.submitButton.querySelector('span');
        this.submitButtonSuccessIcon = this.submitButton.querySelector('.product-form__submit-success-icon');
        this.submitButtonDefaultText = this.submitButtonText?.textContent;
        this.successTimeout = null;
        this.successFeedbackShown = false;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.resetSubmitButtonFeedback(false);
        this.successFeedbackShown = false;
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const activeSellingPlanInput = this.form.querySelector('[name="selling_plan"]:not([disabled])');
        if (activeSellingPlanInput && activeSellingPlanInput.value) {
          formData.delete('properties[_daily_deal]');
          formData.delete('properties[_daily_deal_tag]');
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    this.successFeedbackShown = this.queueSubmitButtonFeedback();
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              this.successFeedbackShown = this.queueSubmitButtonFeedback();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && !this.successFeedbackShown) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        this.resetSubmitButtonFeedback();

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');

          // Preorder Button Text nach dem Re-Render erneut setzen
          const preorderInput = this.variantIdInput;
          const preorderButtonText = preorderInput?.dataset.preorderButtonText;
          const inventory = parseInt(preorderInput?.dataset.inventory);

          if (preorderButtonText && inventory <= 0) {
            this.submitButtonText.textContent = preorderButtonText;
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      showSubmitButtonFeedback() {
        if (this.dataset.enableAtcFeedback !== 'true' || !this.submitButtonText) return false;

        const successText = this.dataset.atcSuccessText;
        if (!successText) return false;

        window.clearTimeout(this.successTimeout);
        this.submitButtonDefaultText = this.submitButtonText.textContent;
        this.submitButtonText.textContent = successText;
        this.submitButton.classList.add('is-success');
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButtonSuccessIcon?.classList.remove('hidden');

        this.successTimeout = window.setTimeout(() => {
          this.resetSubmitButtonFeedback();
        }, 1000);

        return true;
      }

      queueSubmitButtonFeedback() {
        if (this.dataset.enableAtcFeedback !== 'true' || !this.submitButtonText || !this.dataset.atcSuccessText) {
          return false;
        }

        window.setTimeout(() => {
          this.showSubmitButtonFeedback();
        });

        return true;
      }

      resetSubmitButtonFeedback(removeAriaDisabled = true) {
        window.clearTimeout(this.successTimeout);

        if (this.submitButtonText && this.submitButtonDefaultText) {
          this.submitButtonText.textContent = this.submitButtonDefaultText;
        }

        this.submitButton.classList.remove('is-success');
        this.submitButtonSuccessIcon?.classList.add('hidden');
        this.successFeedbackShown = false;

        if (removeAriaDisabled && !this.error && !this.submitButton.hasAttribute('disabled')) {
          this.submitButton.removeAttribute('aria-disabled');
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
